import { Box } from "@material-ui/core";
import {
  TravelerSelectStep,
  TravelerSelectWorkflow,
  useDeviceTypes,
} from "halifax";
import React from "react";
import { CLICKED_ADD_TRAVELER, ClickedAddTravelerProperties } from "redmond";
import clsx from "clsx";
import { RouteComponentProps } from "react-router-dom";

import { isVesperTenant, getConfigTenant } from "@capone/common";
import { TravelerSectionConnectorProps } from "./container";
import "./styles.scss";
import { PATH_HOME } from "../../../../utils/paths";
import { trackEvent } from "../../../../api/v1/analytics/trackEvent";

import {
  AVAILABLE,
  CARS_LOYALTY_SECTION,
  getExperimentVariant,
  addTrackingProperties,
  useExperiments,
} from "../../../../context/experiments";

export interface TravelerSectionProps
  extends TravelerSectionConnectorProps,
    RouteComponentProps {}

export const TravelerSection = (props: TravelerSectionProps) => {
  const {
    history,
    travelers,
    fetchUserPassengers,
    updateUserPassenger,
    deleteUserPassenger,
  } = props;
  const { matchesMobile } = useDeviceTypes();

  const expState = useExperiments();

  const [progress, setProgress] = React.useState<TravelerSelectStep>(
    matchesMobile ? TravelerSelectStep.TravelerSelect : TravelerSelectStep.Main,
  );

  React.useEffect(() => {
    fetchUserPassengers();
  }, []);

  const isVesper = isVesperTenant(getConfigTenant());

  return (
    <Box
      className={clsx("traveler-section", {
        mobile: matchesMobile,
        redesigned: isVesper,
      })}
    >
      <TravelerSelectWorkflow
        handleDeletePassenger={deleteUserPassenger}
        handleUpdatePassenger={updateUserPassenger}
        progress={progress}
        setProgress={setProgress}
        disallowSelect
        selectedTravelerIds={[]}
        travelers={travelers}
        noHeadings
        addNewTravelerButton
        showAdditionalInfoSection
        showDriverLicenseSection
        disableDriversLicenseValidation
        showFrequentFlyerSection
        showGenderField
        showGroundLoyaltySection={
          getExperimentVariant(expState.experiments, CARS_LOYALTY_SECTION) ===
          AVAILABLE
        }
        showNationalityField
        showPassportSection
        editPassenger={undefined}
        isMobile={matchesMobile}
        onMobileBack={() => {
          history.push(PATH_HOME);
        }}
        updatedDesign
        titles={{
          travelerInfoTitle: "Travelers",
          travelerInfoSubtitle:
            "Manage traveler details and frequent flyer programs to speed up the booking process. ",
          frequentFlyerTitle: "Frequent flyer details",
          frequentFlyerSubtitle: isVesper
            ? "You can add an unlimited amount of frequent flyer programs to each traveler."
            : undefined,
          additionalInfoTitle: "Additional information",
          addTravelers: "Add new traveler",
          editTravelerTitle: "Edit traveler",
          travelerInfoFormSubtitle: isVesper
            ? "Ensure all information matches your travel ID. You can't change this information once you place a booking."
            : undefined,
          adultTitle: "Adult",
          childTitle: "Child",
          infantSeatTitle: "Infant (in seat)",
          infantLapTitle: "Infant (on lap)",
          noTravelersTitle: "You haven’t added any travelers yet.",
          passportTitle: "Passport details",
          passportSubtitle:
            "Certain airlines may require you to submit your passport information on international flights. All fields must be completed to be saved successfully.",
          driverLicenseSectionSubtitle: isVesper
            ? "Add driver's license details to save time booking your next car rental."
            : undefined,
          travelerInfoSectionTitle: "Traveler information",
        }}
        travelerSelectContentOnly
        onClickAddNewTraveler={() => {
          trackEvent({
            eventName: CLICKED_ADD_TRAVELER,
            properties: addTrackingProperties(expState.trackingProperties, {
              entry_type: "customer_profile",
            } as ClickedAddTravelerProperties),
          });
        }}
      />
    </Box>
  );
};
